//color
export enum Color {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

// comp Label
export enum VariantLabel {
  FILLED = 'filled',
  OUTLINED = 'outlined',
  GHOST = 'ghost',
  SOFT = 'soft',
}

// comp Popover
export enum PopoverType {
  ALL = 'all',
  EDIT = 'edit',
  DELETE = 'delete',
}
